import styles from './searchResults.module.css';
import Tracklist from './Tracklist';

function SearchResults(props) {

    return (
    <div className={styles.Results} >
        <h2>Search Results</h2>
        <div className={styles.SearchResults}>
          <Tracklist tracks={props.tracks} isRemove={false} onAdd={props.onAdd} />
        </div>
    </div>
  );
}

export default SearchResults;
